import common from "../common";

export default class ToggleButton extends P3.Button
{
    constructor(buttonStates)
    {
        super(buttonStates);
        this._toggled = false;
    }

    appear(delay = 0)
    {
        console.log(delay);
        this.scale.set(0);
        this.transitionAnimating = true;
        TweenMax.to(this.scale, 0.3, {delay:delay, x:1, y:1, ease:Expo.easeOut, onComplete:() => {
            this.transitionAnimating = false;
        }});
    }

    disappear(delay = 0)
    {
        console.log(delay);
        this.scale.set(1);
        this.transitionAnimating = true;
        TweenMax.to(this.scale, 0.3, {delay:delay, x:0, y:0, ease:Back.easeIn, onComplete:() => {
            this.transitionAnimating = false;
        }});
    }

    onMouseDown(e)
    {
        //common.audio.playSound(this.clickSound);
        if(!this.transitionAnimating)
            super.onMouseDown(e);
    }

    onMouseOver(e)
    {
        if(!this.transitionAnimating)
            super.onMouseOver(e);
    }

    onMouseOut(e)
    {
        if(!this.transitionAnimating)
            super.onMouseOut(e);
    }

	onMouseClick(event)
	{
	    this.toggle();

	    super.onMouseClick.call(this, event);
	}

	get toggled()
	{
	   return this._toggled;
	}

	toggle()
	{
        this._toggled = !this._toggled;

        //this._currentNormalTexture = this.toggled ? this._states.normalAlt : this._states.normal;
        //this._currentOverTexture = this.toggled ? this._states.overAlt : this._states.over;
        //this._currentDownTexture = this.toggled ? this._states.downAlt : this._states.down;
        this._currentIconTexture = this.toggled ? this._states.iconAlt : this._states.icon;
        //this._currentIconOverTexture = this.toggled ? this._states.iconOverAlt : this._states.iconOver;
        //this._currentIconDownTexture = this.toggled ? this._states.iconDownAlt : this._states.iconDown;

        //this._states.normal && (this._background.texture = this._currentNormalTexture);
        this._states.icon && (this._icon.texture = this._currentIconTexture);
    }
}